<template>
    <div>
        <button
            :class="buttonClasses"
            @click="openModal"
        >
            <slot name="button" />
        </button>

        <dialog ref="modal" class="modal">
            <div class="modal-box w-10/12 max-w-[800px] max-h-[80%] min-h-96 z-20 flex flex-col gap-4" @click.stop>
                <form method="dialog" class="flex justify-end">
                    <button class="flex gap-1 items-center py-2.5 text-placeholder hover:cursor-pointer" @click="close">
                        <span class="text-lg font-semibold text-placeholder">
                            <slot name="name">{{ t('layout.default.closeModal') }}</slot>
                        </span>
                        <MiscIcon name="close" size="lg" />
                    </button>
                </form>

                <div v-if="isOpen" class="text-lg">
                    <slot name="content" />
                </div>
            </div>
        </dialog>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    buttonClasses?: string
}>()

const { t } = useI18n()
const modal = ref(null)
const isOpen = ref(false)

function close() {
    modal.value.close()
    isOpen.value = false
}

function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' && isOpen.value) {
        close()
    }
}

function openModal() {
    modal.value.showModal()
    isOpen.value = true
    emit('opened-modal')
}

const emit = defineEmits<{
    (event: 'opened-modal'): void
}>()

onMounted(() => {
    document.addEventListener('keydown', handleKeydown)

    if (modal.value) {
        modal.value.addEventListener('mousedown', (event: MouseEvent) => {
            if (event.target === modal.value) {
                close()
            }
        })
    }
})

onUnmounted(() => {
    document.removeEventListener('keydown', handleKeydown)

    if (modal.value) {
        modal.value.removeEventListener('mousedown', close)
    }
})

defineExpose({
    close,
    open: openModal
})
</script>